export default "__VITE_ASSET__BFsaVsVx__"